import React from "react";
import Keycloak from "keycloak-js";
import { asyncNoop, falseFn } from "../utils.js";

export type KeycloakAuth = Pick<
  Keycloak,
  | "token"
  | "updateToken"
  | "login"
  | "logout"
  | "register"
  | "idTokenParsed"
  | "createRegisterUrl"
>;

export interface AuthContext {
  isReady: boolean;
  isAuthenticated: boolean;
  belongsToGroup: (groupName: string) => boolean;
  auth: KeycloakAuth;
}

export const AuthContext = React.createContext<AuthContext>({
  isReady: false,
  isAuthenticated: false,
  belongsToGroup: falseFn,
  auth: {
    token: undefined,
    updateToken: asyncNoop,
    login: asyncNoop,
    logout: asyncNoop,
    register: asyncNoop,
    createRegisterUrl: dummyCreateRegisterUrl,
    idTokenParsed: undefined,
  },
});

async function dummyCreateRegisterUrl() {
  return "";
}
